import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, SyncData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PrintIcon from '@mui/icons-material/Print';
import EstimatePrint from '../SaleOrder/Estimate';
import { useParams, useHistory } from 'react-router-dom';


function SaleOrderIndex() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [orderdate, setOrderdate] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    // const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);
    //vehicletype

    const [vehicletypeId, setvehicletypeId] = useState('');
    const [vehicletypeOptions, setvehicletypeOptions] = useState([]);
    const [selectedvehicletype, setSelectedvehicletype] = useState(null);


    useEffect(() => {
        const fetchVehicleTypes = async () => {
            try {
                const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(vehtype => ({
                        value: vehtype.id,
                        label: vehtype.name
                    }));
                    setvehicletypeOptions(options);
                }
            } catch (error) {
                console.error('Error fetching vehicle models:', error);
            }
        };

        fetchVehicleTypes();
    }, [companyId, token]);

    //Vehicle
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState("");
    const [selectedVehicleId, setSelectedVehicleId] = useState("");

    const handleVehicletypeChange = async (selectedOption) => {
        setSelectedvehicletype(selectedOption);

        try {
            const response = await fetchData('VehicleTypeApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(vehicle => ({
                    value: vehicle.id,
                    label: vehicle.vehicleNo
                }));
                setVehicleOptions(options);
            }
        } catch (error) {
            console.error('Error fetching vehicle options:', error);
        }
    };


    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    // Function to get tomorrow's date in 'YYYY-MM-DD' format
    const getTomorrowDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    };
    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = currentDate.getDate();
        day = day < 10 ? '0' + day : day;
        return `${year}-${month}-${day}`;
    };
    const [filteredData, setFilteredData] = useState([]);
    const [selectrouteid, setSelectedRouteId] = useState([]);
    const [selectroutename, setSelectedRoutname] = useState([]);

    const handleRouteTypeChange = async (RouteselectedOption) => {
        setSelectedRoute(RouteselectedOption);
        setSelectedRouteId(RouteselectedOption.value);
        setSelectedRoutname(RouteselectedOption.label);
   // }
    // const handleVehicleChange = (vehicleselectedOption) => {
    //     setSelectedVehicle(vehicleselectedOption);
    //     setSelectedVehicleId(vehicleselectedOption.value);


        try {
            if (RouteselectedOption && RouteselectedOption.value) {
                const orderDateOnly = orderDate.split('T')[0];
                const tripDateOnly = tripDate.split('T')[0]; // Extract only date part from tripDate
                const CreateData = {
                    // Description: null,
                    Description: tripDateOnly + " " + RouteselectedOption.label, //selectedOption.label,
                    SalesManId: null,
                    DriverId: null,
                   // VehicleId: vehicleselectedOption.value,
                    RouteId: RouteselectedOption.value, // accessing selectedOption.value directly
                    //RouteId: selectrouteid,
                    StartAudometereReading: null,
                    EndAudometereReading: null,
                    TripDate: tripDate,
                    OrderDate: orderDateOnly,
                    CreatedBy: userId,
                    CompanyId: companyId,
                    CreatedDate: new Date(),
                };

                postData('TripApi', CreateData, token)
                    .then((response) => {
                        if (CreateData.Description === response.description) {
                            alert('⚠️ Trip already exists with the same Trip Date and Route !');
                            // history.push('/Home');
                        } else {
                            const tripid = response.tripId;
                            history.push(`/TriporderedIndexs/${tripid}`);
                        }

                    })
                    .catch((error) => {
                        console.error('Item Create error:', error);
                        setIsLoading(false);
                    });
            } else {
                console.error('Selected option is null or undefined.');
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };


    const handleDelete = async () => {
        deleteData('CustomerApi', `${deleteItemId}`, token)
            .then((response) => {
                //fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleSaleOrderPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('SaleOrderApi', `/SaleorderPrint/${SaleOrderid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            // Render EstimatePrint component inside iframe
            ReactDOM.render(
                <EstimatePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }


    };
    useEffect(() => {
        setTripDate(getTomorrowDate());
    }, []);


    const handleToDateChange = (e) => {
        setTripDate(e.target.value);
    };
    const handleToDateChangeOrderDate = (e) => {
        setOrderDate(e.target.value);
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>

                <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>SALE ORDER</h5>
            </div>
            <div className='w-full mb-2 flex'>
                <div className="w-1/6 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2 mr-4" htmlFor="toDate" style={{ fontSize: '14px', fontWeight: 'bolder' }}>
                        Order Date
                    </label>
                    <input
                        id="currentDate"
                        type="date"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        value={orderDate}
                        onChange={handleToDateChangeOrderDate}
                    />
                </div>

                <div className="w-1/6 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2 mr-4" htmlFor="toDate" style={{ fontSize: '14px', fontWeight: 'bolder' }}>
                        Trip Date
                    </label>
                    <input
                        id="toDate"
                        type="date"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        value={tripDate}
                        min={getFormattedCurrentDate()}
                        onChange={handleToDateChange}
                    />
                </div>

                <div className="w-1/4 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                        Route
                    </label>
                    <Select
                        value={selectedRoute}
                        onChange={handleRouteTypeChange}
                        options={routeOptions}
                        placeholder="Select Route"
                        isSearchable
                    />
                </div>
                {/* <div className="w-1/4 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                        Vehicle Model
                    </label>
                    {<Select
                        value={selectedvehicletype}
                        onChange={handleVehicletypeChange}
                        options={vehicletypeOptions}
                        placeholder="Vehicle Model"
                        isSearchable

                    />}

                </div>
                <div className="w-1/4 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                        Vehicle No.
                    </label>
                    {<Select
                        value={selectedVehicle}
                        onChange={handleVehicleChange}
                        options={vehicleOptions}
                        placeholder="Select Vehicle"
                        isSearchable

                    />}

                </div> */}
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#0B5345' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '50px' }}>R.SequenceNo</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', textAlign: 'left' }}>Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.Bill Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.Outstanding</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Item Count</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>
                            {data.map((item, index) => (
                                <TableRow key={item.id} className="size">
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'black', fontWeight: 'bolder', padding: '2px', width: '50px', textAlign: 'center' }}>{item.routeSequenceNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'black', fontWeight: 'bolder', padding: '2px' }}>{item.name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'black', fontWeight: 'bolder', padding: '2px', fontSize: '16px' }}>{item.contactNumber1} , {item.contactNumber2} </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}>{item.itemcount}</TableCell>

                                    <TableCell>
                                        {item.saleorderfinish === true ? (
                                            <Link to={`/SaleOrderCreate/${item.id}`}>
                                                <Tooltip title="Create Sale Order">
                                                    <IconButton>
                                                        <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Link>
                                        ) : (
                                            <Tooltip title="Generate the Saleorder Bill">
                                                <Button onClick={() => handleSaleOrderPrint(item.saleorderid)} style={{ backgroundColor: 'orange', color: "whitesmoke", fontWeight: 'bolder' }}>
                                                    {/* <PrintIcon style={{ color: 'blue', fontWeight: 'bold' }} /> */}
                                                    Generate Invoice
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>


                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );
}

export default SaleOrderIndex;

